<template>
  <section class="document-summary">
    <h2 class="document-summary__title" v-html="getTitleBlock(page, 'summary', 'title')"></h2>
    <div class="document-summary__grid">
      <article v-for="(item, index) in getListBlock(page, 'summary-list')" :key="index" class="document-summary__card">
        <h3 class="document-summary__question" v-html="item.key"></h3>
        <p class="document-summary__answer" v-html="item.value"></p>
      </article>
    </div>
  </section>
</template>

<script>
import { textBlock } from '@/entities/text-block';

export default {
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  mixins: [ textBlock ],
};
</script>

<style lang="scss" scoped>
.document-summary {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;

  &__title {
    margin: 0 0 32px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: clamp(32px, 4vw, 52px);
    line-height: 1.1;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
  }

  &__card {
    padding: 24px;
    border-radius: 20px;
    background: #FFFFFF;
    box-shadow: 0 16px 48px rgba(55, 58, 61, 0.10);
  }

  &__question {
    margin: 0 0 10px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 19px;
    line-height: 26px;
  }

  &__answer {
    margin: 0;
    font-size: 16px;
    line-height: 25px;
    color: #494E53;
  }
}
</style>
